<template>
  <div class="form-group">
    <label for="price-filter" class="mb-2">
      {{ translate("PRODUCT.FILTERS.PRICE_LABEL") }}
    </label>

    <div class="input-group" :class="{ 'price-filter-invalid': !isPriceValid }">
      <input
        v-model="modelValue.min"
        class="form-control"
        id="min-value-price"
        type="number"
        :placeholder="translate('PRODUCT.FILTERS.MIN_PLACEHOLDER')"
      />

      <input
        v-model="modelValue.max"
        class="form-control"
        id="max-value-price"
        type="number"
        :placeholder="translate('PRODUCT.FILTERS.MAX_PLACEHOLDER')"
      />
    </div>

    <p v-if="!isPriceValid" class="price-filter-warning">
      {{ translate("PRODUCT.FILTERS.PRICE_INVALID") }}
    </p>
  </div>
</template>

<script setup>
/* eslint no-unused-vars:off */
import { computed } from "vue";
import PriceFilter from "@/view/components/Shared/PriceFilter.vue";
import useTranslate from "@/core/composables/translate";

const { translate } = useTranslate();

const { modelValue } = defineProps({
  modelValue: {
    value: PriceFilter,
    required: true,
  },
});

const isPriceValid = computed(() =>
  modelValue?.min && modelValue?.max ? parseFloat(modelValue.min) <= parseFloat(modelValue.max) : true
);
</script>

<style scoped lang="scss">
.price-filter-warning {
  margin: 0.25rem 0 0.5rem 0;
  color: $cirx-primary-red;
  font-size: 0.9rem;
}

#price-filter.price-filter-invalid input {
  border-color: $cirx-primary-red;
}
</style>
